import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { LinearStateFlowContainer } from "components/common";
//#endregion
import { getVatReportLifecycle } from "./vatReportModel";

interface VatReportStateFlowProps {
  status: WintSuperkollAPIModel.VatReportStatus;
}

/**
 * Sparad → Bokad → Väntar på signering → Signerad & inskickad. The API reports where the report is,
 * not when or by whom each step happened, so every step goes in without a date or a person.
 */
const VatReportStateFlow: React.FC<VatReportStateFlowProps> = ({ status }) => {
  const steps: WintSuperkollAPIModel.EntityStateLog[] = getVatReportLifecycle(status).map(({ step, active }) => ({
    status: step,
    active,
    isIntermediateState: false,
  }));

  return <LinearStateFlowContainer steps={steps} translationKey="Advisor.VatReportLifecycle" />;
};

export default VatReportStateFlow;
